import styled from 'styled-components';
import { claudeDark } from '../tokens';

const Card = styled.button`
  display: flex; flex-direction: column; gap: 10px; text-align: left;
  background: ${claudeDark.surfaceElevated}; border: 1px solid ${claudeDark.border};
  border-radius: ${claudeDark.radiusLg}; padding: 22px; cursor: pointer;
  font-family: ${claudeDark.fontSans}; transition: box-shadow .15s, transform .15s, border-color .15s;
  &:hover { box-shadow: 0 4px 18px rgba(0,0,0,.45); transform: translateY(-2px); border-color: ${claudeDark.accent}; }
`;
const Icon = styled.div`
  width: 44px; height: 44px; border-radius: ${claudeDark.radiusMd};
  background: color-mix(in srgb, ${claudeDark.accent} 13%, transparent); color: ${claudeDark.accent};
  display: grid; place-items: center; font-size: 22px;
`;
const Name = styled.div`font: 600 17px ${claudeDark.fontSans}; color: ${claudeDark.textPrimary};`;
const Blurb = styled.div`font: 400 13.5px/1.5 ${claudeDark.fontSans}; color: ${claudeDark.textSecondary};`;
const Tag = styled.span`
  align-self: flex-start; font: 500 11px ${claudeDark.fontMono};
  color: ${claudeDark.accent}; background: color-mix(in srgb, ${claudeDark.accent} 13%, transparent);
  border-radius: 999px; padding: 3px 10px;
`;

export default function AgentCard({ icon, name, blurb, tag, onOpen }) {
  return (
    <Card onClick={onOpen} aria-label={`Open ${name}`}>
      <Icon>{icon}</Icon>
      <Name>{name}</Name>
      <Blurb>{blurb}</Blurb>
      <Tag>{tag}</Tag>
    </Card>
  );
}
